module.exports = __webpack_public_path__ + "img/H1.16e5b262.png";